var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-avis-module',{attrs:{"avis":_vm.avis}})
}
var staticRenderFns = []

export { render, staticRenderFns }